<template>
  <v-app>
    <v-main>
      <div class="grey lighten-4 h-screen pt-17 mb-18">
        <v-card
          rounded="0"
          elevation="1"
          class="position-fixed z-5 w-100 top-0 py-4"
        >
          <div class="text-center high-emp w-100 subtitle1-regular">
            ویرایش {{ person }} منتخب
          </div>
        </v-card>

        <loading v-if="loading" class="h-half-screen"></loading>

        <template v-else>
          <v-form v-if="type == 'load'" v-model="validate" class="mobile-container">
            <selected-load-form
              :load="draft"
              form-type="edit"
            ></selected-load-form>
            <v-card
              rounded="0"
              class="
                pa-2
                position-fixed
                bottom-0
                w-100
                border
                d-block
                z-5
                ev-0
                px-md-30
              "
            >
              <v-row class="mx-0">
                <v-col cols="6" class="px-2 py-0">
                  <v-btn
                    outlined
                    class="
                      white
                      border-outline
                      d-flex
                      justify-center
                      align-center
                      logistic--text
                      force-color
                      rounded
                      w-100
                      py-6
                    "
                    @click="$router.push('/Panel/SelectedLoadsAddresses')"
                  >
                    انصراف
                  </v-btn>
                </v-col>
                <v-col cols="6" class="px-2 py-0">
                  <v-btn
                    @click="update()"
                    :loading="btnLoading"
                    :disabled="!validate || checkSame"
                    class="w-100 logistic-color white--text py-6"
                    elevation="0"
                  >
                    به روز رسانی
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-form>

          <sender-receiver-draft-form
            v-else
            :draft="draft"
            :type="type"
          ></sender-receiver-draft-form>
        </template>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import SenderReceiverDraftForm from "../components/SenderReceiverDraftForm.vue";
import SelectedLoadForm from "../components/SelectedLoadForm.vue";

export default {
  components: { SenderReceiverDraftForm, SelectedLoadForm },
  data() {
    return {
      draft: {},
      loading: true,
      validate: false,
      checkSame: false,
      btnLoading: false,
    };
  },
  created() {
    this.fetchDraft();
  },
  methods: {
    async fetchDraft() {
      const draftId = this.$route.params.draft_id;

      const request =
        this.type == "load"
          ? {
              url: "get_company_draft_load",
              params: {
                draftId: draftId,
              },
            }
          : {
              url: "get_darft_address_by_company",
              params: {
                draft_id: draftId,
              },
            };

      const res = await this.$parseSDK.Cloud.run(request.url, request.params);
      if (res) {
        this.draft = JSON.parse(JSON.stringify(res));
      }
      this.loading = false;
    },
    async update() {
      this.btnLoading = true;
      let {
        ACL,
        createdAt,
        status,
        objectId,
        updatedAt,
        user_id,
        price_by_company,
        ...draft
      } = this.draft;
      draft.draftId = this.$route.params.draft_id;
      //convert to rial
      draft.price = draft.price * 10;
      //convert to standard multi vehicle list
      draft.vehicles = this.$utils.standardMultiVehicleList(draft.vehicles);

      const res = await this.$parseSDK.Cloud.run(
        "edit_company_draft_load_array",
        draft
      ).catch((err) => {
        this.$utils.handleErrorIfKnown(err.message);
      });

      if (res) {
        this.$router.push("/Panel/SelectedLoadsAddresses");
        this.$utils.showMessage("با موفقیت ویرایش شد", {
          type: "success",
        });
      }
      this.btnLoading = false;
    },
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    person() {
      const type = this.$route.params.type;
      let type_text = null;
      switch (type) {
        case "sender":
          type_text = "فرستنده";
          break;
        case "reciever":
          type_text = "گیرنده";
          break;
        case "load":
          type_text = "بار";
          break;

        default:
          type_text = "فرستنده";
          break;
      }
      return type_text;
    },
  },
};
</script>


<style scoped lang="scss">
.h-screen {
  min-height: 100vh;
}
.h-half-screen {
  min-height: calc(100vh - 240px);
}
.pt-17 {
  padding-top: 66px;
}
.mb-18 {
  padding-bottom: 78px;
}
@media (min-width: 960px) {
  .px-md-30 {
    padding-right: 25vw !important;
    padding-left: 25vw !important;
  }
}
.border-outline {
  border: none;
  outline: 0.5px solid rgba(0, 0, 0, 0.12) !important;
}
</style>